<template>
  <section class="py-20 border border-gray-200" v-if="getOpenHouseEnabled && getOpenHouseDays.length > 0">
    <Container className="lg:flex gap-24">
      <div class="flex-none w-full lg:w-80 mb-8 text-center lg:text-left lg:mb-0">
        <SectionHeader>Open<br>House</SectionHeader>
      </div>

      <div class="flex-1">
        <div class="flex flex-wrap justify-center lg:justify-end gap-x-20 gap-y-10">
          <div class="text-center space-y-4" v-for="day in getOpenHouseDays" :key="day.id">
            <div>
              <FontAwesomeIcon
                icon="calendar-day"
                class="size-12 text-secondary-color"
              />
            </div>
            <div 
              class="text-xl font-semibold uppercase tracking-widest text-secondary-color"
            >
              {{ new Date(day.day) | date('MMM dd, yyyy') }}
            </div>
            <div class="text-sm font-medium uppercase tracking-widest text-slate-700">
              {{ new Date(day.start) | date('h:mm a') }} -
              {{ new Date(day.end) | date('h:mm a') }}
            </div>
          </div>
        </div>
      </div> 
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  import { dateFilter } from 'vue-date-fns';

  import Container from '../../components/Container';
  import SectionHeader from '../../components/SectionHeader';
  
  export default {
    name: 'OpenHouse',
    components: {
      Container,
      SectionHeader
    },
    filters: {
      date: dateFilter
    },
    computed: {
      ...mapGetters("tour", ['getOpenHouseEnabled', 'getOpenHouseDays', 'getPrimaryColor']),
    },
  };
</script>
